// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1b-94","insightsList":"newBusinessInsightsMenu_insightsList__1BaB7","active":"newBusinessInsightsMenu_active__2FlGT"};